import { render, staticRenderFns } from "./FederationTable.vue?vue&type=template&id=552444c2&"
import script from "./FederationTable.vue?vue&type=script&lang=js&"
export * from "./FederationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports